import { Component, OnInit, signal } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter, map } from 'rxjs/operators';


@Component({
  selector: 'app-pwa-update',
  standalone: true,
  imports: [],
  template: `
    @if (updateAvailable()) {
      <div class="update-notification">
        <div class="update-content">
          <p>A new version of this app is available.</p>
          <button id="pwa-update-confirm-btn" (click)="updateApp()">Update Now</button>
        </div>
      </div>
    }
    @if (offline()) {
      <div class="offline-notification">
        <div class="offline-content">
          <p>You are currently offline. Some features may be limited.</p>
        </div>
      </div>
    }
    `,
  styles: [`
    .update-notification, .offline-notification {
      position: fixed;
      bottom: 20px;
      right: 20px;
      z-index: 1000;
      padding: 15px;
      border-radius: 4px;
      box-shadow: 0 4px 8px rgba(0,0,0,0.2);
      max-width: 350px;
    }
    
    .update-notification {
      background-color: #333333;
      color: white;
    }
    
    .offline-notification {
      background-color: #ff9800;
      color: white;
    }
    
    button {
      background-color: white;
      color: #333333;
      border: none;
      border-radius: 4px;
      padding: 8px 16px;
      margin-top: 8px;
      cursor: pointer;
      font-weight: bold;
    }
  `]
})
export class PwaUpdateComponent implements OnInit {
  updateAvailable = signal<boolean>(false);
  offline = signal<boolean>(false);

  constructor(private swUpdate: SwUpdate) {
    this.checkOnlineStatus();
    window.addEventListener('online', this.checkOnlineStatus.bind(this));
    window.addEventListener('offline', this.checkOnlineStatus.bind(this));
  }

  ngOnInit(): void {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates
        .pipe(
          filter((event): event is VersionReadyEvent => event.type === 'VERSION_READY'),
          map((event: VersionReadyEvent) => {
            // console.log('Current version:', event.currentVersion);
            // console.log('Available version:', event.latestVersion);
            return true;
          })
        )
        .subscribe(() => {
          this.updateAvailable.set(true);
        });
        
      // Check for updates every 6 hours
      setInterval(() => {
        this.swUpdate.checkForUpdate();
      }, 6 * 60 * 60 * 1000);
    }
  }

  updateApp(): void {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.activateUpdate().then(() => document.location.reload());
    }
  }

  private checkOnlineStatus(): void {
    this.offline.set(!navigator.onLine);
  }
}
